import { FC, PropsWithChildren } from 'react';
import { useCountry } from 'hooks';

export const CurrencySuffix: FC<PropsWithChildren> = ({ children }) => {
	// ! selectors
	const { selectedCountryCurrencyCode } = useCountry();

	// ! render
	return (
		<span>
			{children} {selectedCountryCurrencyCode}
		</span>
	);
};
